<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8.193" height="9.819" viewBox="0 0 8.193 9.819">
    <g id="arrow-right" transform="translate(8.192) rotate(90)">
      <path
        id="Path"
        d="M.818,4.91H7.025L5.149,6.786A.818.818,0,1,0,6.306,7.943L9.578,4.671a.818.818,0,0,0,0-1.159L6.306.239A.819.819,0,1,0,5.149,1.4L7.025,3.274H.818a.818.818,0,1,0,0,1.636Z"
        transform="translate(0 -0.001)"
        :fill="props.color"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface ArrowRightProps {
  color?: string;
}

const props = withDefaults(defineProps<ArrowRightProps>(), {
  color: "#00a1aa",
});
</script>
